import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from "rxjs";

const URL_BASE = environment.URL_BACKEND;

@Injectable({
  providedIn: 'root'
})
export class SuccessService {

  constructor(private readonly http: HttpClient) { }

  validate(empresaId: number): Observable<void> {
    return this.http.get<void>(`${URL_BASE}/payments/${empresaId}`);
  }
}
